export default {
    Order: require('./Order').default
  }